import {Component, OnInit, ViewChild} from '@angular/core';
import {TdoTableComponent} from '../../../tdo-controls/common/tdo-table/tdo-table.component';
import {TdoClientConfigurationModel} from '../../../models/clients/tdo-client-configuration.model';
import {ClientLocationDataModel} from '../../../models/clients/client-location-data.model';
import {EnumPaymentProcessorModel} from '../models/enum-payment-processor.model';
import {MatSnackBar} from '@angular/material/snack-bar';
import {Globals} from '../../../globals';
import {DialogService} from '../../../services/dialog.service';
import {MatDialog} from '@angular/material/dialog';
import {ConfigurationService} from '../configuration.service';
import {UntypedFormBuilder} from '@angular/forms';
import {ClaimsProcessorConfigurationService} from './claims-processor-configuration-service';
import {CfgArClaimProcessorModel} from '../../../models/configuration/cfg-ar-claim-processor.model';
import {enumValidValueItem} from '../../ar/_models/ar.models';
import {TdoTableSelectionEvent} from '../../../tdo-controls/common/tdo-table-v2/models/tdo-table-selection.event';
import {TdoTableV2Component} from '../../../tdo-controls/common/tdo-table-v2/tdo-table-v2.component';
import {CfgArClaimProcessorForLocation} from '../../../models/configuration/cfg-ar-claim-processor-for-location';
import {CfgArClaimProcessorForLocationsListModel} from '../../../models/configuration/cfg-ar-claim-processor-for-locations-list.model';

@Component({
    selector: 'app-claims-processor-configuration',
    templateUrl: './claims-processor-configuration.component.html',
    styleUrls: ['./claims-processor-configuration.component.scss']
})
export class ClaimsProcessorConfigurationComponent implements OnInit {

    @ViewChild('processorTable', {static: false}) processorTable: TdoTableV2Component;
    @ViewChild('locationTable', {static: false}) locationTable: TdoTableV2Component;

    claimProcessorList: CfgArClaimProcessorModel[] = [];
    claimProcessorTypesList: enumValidValueItem[] = [];
    claimProcessorLocations: CfgArClaimProcessorForLocation[] = [];
    claimProcessorLocationsRevert: CfgArClaimProcessorForLocation[] = [];
    claimProcessorLocationList: CfgArClaimProcessorForLocationsListModel[] = [];
    selectedProcessor: CfgArClaimProcessorModel;
    selectedProcessorRevert: CfgArClaimProcessorModel;
    connectionParametersJSON: any; // needs to any type, because we're getting unknown json structure from backend
    locationList: ClientLocationDataModel[] = [];

    blankProcessor: string = '{"Username":"","Password":"","APIKey":"", "DXCGroupID":""}';

    dxc_UserName: string = '';
    dxc_password: string = '';
    dxc_APIKey: string = '';
    dxc_DXCGroupID: string = '';


    clientList: TdoClientConfigurationModel[] = [];
    enumProcessors: EnumPaymentProcessorModel[] = [];
    selectedClient: TdoClientConfigurationModel;
    selectedLocation: ClientLocationDataModel;

    isSaved: boolean = false;
    saveDisabled: boolean = true;
    isEditing: boolean = false;
    isLoading: boolean = false;

    PasswordEyeShow: boolean = false;
    PasswordEyeShowMode: string = 'password';

    enumARProcessorIDWorldPayIframe = '00000205-1000-0000-0000-000000000001';
    enumARProcessorIDSquare = '00000205-1000-0000-0000-000000000002';
    enumARProcessorIDTriPosLane3000 = '00000205-1000-0000-0000-000000000003';

    constructor(
        private snackBar: MatSnackBar,
        private globals: Globals,
        private dialogService: DialogService,
        private snackbar: MatSnackBar,
        private dialog: MatDialog,
        private claimsProcessorConfigService: ClaimsProcessorConfigurationService,
        public configurationService: ConfigurationService,
        private fb: UntypedFormBuilder,
    ) { }

    async ngOnInit(): Promise<void> {

        this.selectedProcessor = new CfgArClaimProcessorModel();

        const promises: any[] = [
            this.claimsProcessorConfigService.GetClaimProcessors().toPromise(),
            this.claimsProcessorConfigService.GetLocations().toPromise(),
            this.claimsProcessorConfigService.GetClaimProcessorTypes().toPromise(),
        ];

        const results: any[] = await Promise.all(promises);

        this.claimProcessorList = results[0];
        this.locationList = results[1];
        this.claimProcessorTypesList = results[2];

        // build location list
        this.locationList.forEach(loc => {
            const locList = new CfgArClaimProcessorForLocationsListModel();
            locList.Name = loc.Name;
            locList.isDefaultProcessor = false;
            locList.isProcessorLocation = false;
            locList.LOCID = loc.LOCID;
            this.claimProcessorLocationList.push(locList);
        });



        this.claimProcessorList.forEach(a => {
            if ( a.enumARClaimProcessorID === '00000223-1000-0000-0000-000000000001')  // DX
            {
                if (a.ConnectionParametersJSON.indexOf('DXCGroupID') < 0  ) {
                    a.ConnectionParametersJSON = a.ConnectionParametersJSON.replace('}', ', "DXCGroupID":""}');
                }

            }

        });




        this.processorTable.updateData(this.claimProcessorList);
        this.locationTable.updateData(this.claimProcessorLocationList);
    }

    revertSelectedProcessor() {
        if (this.selectedProcessor && this.selectedProcessorRevert) {
            this.claimProcessorList.forEach(a => {
                if (this.selectedProcessor.ClaimProcessorID === a.ClaimProcessorID) {
                    this.selectedProcessor.enumARClaimProcessorID = this.selectedProcessorRevert.enumARClaimProcessorID;
                    this.selectedProcessor.Name = this.selectedProcessorRevert.Name;
                    this.selectedProcessor.WebSiteURL = this.selectedProcessorRevert.WebSiteURL;
                    this.selectedProcessor.ConnectionParametersJSON = this.selectedProcessorRevert.ConnectionParametersJSON;
                    this.claimProcessorLocations = this.claimProcessorLocationsRevert;
                    this.setLocationSelections(this.selectedProcessor.ClaimProcessorID);
                }
            });
        }
    }

    // onTdoTableItemClick(event: CfgArClaimProcessorModel): void {
    //   this.revertSelectedProcessor();
    //
    //   this.selectedProcessor = event;
    //   this.setProcessorDetails();
    //
    //   this.isEditing = false;
    //   this.saveDisabled = true;
    // }

    onEdit(event) {
        this.saveDisabled = false;
        this.isEditing = true;
    }

    onSave(event, showConfirmation: boolean = true) {

        // save processor
        this.isLoading = true;

        const z = JSON.parse( this.blankProcessor);
        z.password = this.dxc_password;
        z.DXCGroupID = this.dxc_DXCGroupID;
        z.UserName = this.dxc_UserName;
        z.APIKey = '';


        // turn json object back into string
        this.selectedProcessor.ConnectionParametersJSON = JSON.stringify(z);

        // save changes to db
        this.claimsProcessorConfigService.saveClaimProcessor(this.selectedProcessor).subscribe(saved => {
            if (saved)
            {
                // save successful
                if (showConfirmation) {
                    this.createMessage('Processor saved', 'Success');
                }

                // if new processor
                const processor = this.claimProcessorList.filter(a => a.ClaimProcessorID === saved.ClaimProcessorID);
                if (processor.length === 0)
                {
                    this.claimProcessorList.push(saved);
                }

                // need to refresh processor list table
                this.isSaved = true;
                this.selectedProcessor = saved;
                this.setSelectedProcessorRevert();
                this.processorTable.updateData(this.claimProcessorList);



                // build locations selected list
                this.claimProcessorLocations = [];
                this.claimProcessorLocationList.forEach(locList => {
                    if (locList.isProcessorLocation) {
                        const loc = new CfgArClaimProcessorForLocation();
                        loc.isDefaultProcessor = locList.isDefaultProcessor;
                        loc.LOCID = locList.LOCID;
                        loc.ClaimProcessorID = this.selectedProcessor.ClaimProcessorID;
                        this.claimProcessorLocations.push(loc);
                    }
                });

                this.claimsProcessorConfigService.saveClaimProcessorLocations(this.selectedProcessor.ClaimProcessorID, this.claimProcessorLocations).subscribe(saved => {
                    if (saved)
                    {
                    // save successful
                        if (showConfirmation) {
                            this.createMessage('Processor locations saved', 'Success');
                        }
                    }
                }, err => {
                    this.createMessage('Error saving processor locations', 'Error');
                    this.isLoading = false;
                });

                this.isLoading = false;



            }
        }, err => {
            this.createMessage('Error saving processor', 'Error');
            this.isLoading = false;
        });


        // reset saved vars
        this.isSaved = false;
    }

    onCancel(event) {
        this.saveDisabled = true;
        this.isEditing = false;

        // revert changes
        this.revertSelectedProcessor();
    }

    onNewProcessor(event) {
    // first clear any previous values set
        this.resetProcessorDetails();

        // set empty by default
        this.selectedProcessor = new CfgArClaimProcessorModel();
        this.selectedProcessor.enumARClaimProcessorID = '00000223-1000-0000-0000-000000000001';
        this.selectedProcessor.WebSiteURL = '';

        this.selectedProcessor.ConnectionParametersJSON = this.blankProcessor;

        this.dxc_UserName = '';
        this.dxc_DXCGroupID = '';
        this.dxc_password = '';
        this.dxc_APIKey = 'Set on server';


        this.connectionParametersJSON = JSON.parse(this.selectedProcessor.ConnectionParametersJSON);

        // this.setSelectedProcessorRevert(); // might not want this here, possibly set revert after save




        this.saveDisabled = false;
        this.isEditing = true;
    }

    setProcessorDetails() {

        // load location selections
        this.setLocationSelections(this.selectedProcessor.ClaimProcessorID);

        if (this.selectedProcessor.ConnectionParametersJSON && this.selectedProcessor.ConnectionParametersJSON !== '') {
            this.connectionParametersJSON = JSON.parse(this.selectedProcessor.ConnectionParametersJSON);
        }

        this.setSelectedProcessorRevert();
    }

    async setLocationSelections(ClaimProcessorID: string) {
        this.claimProcessorLocationList.forEach(a => {
            a.isProcessorLocation = false;
            a.isDefaultProcessor = false;
        });

        const promises: any[] = [
            this.claimsProcessorConfigService.GetClaimProcessorLocations(ClaimProcessorID).toPromise(),
        ];

        const results: any[] = await Promise.all(promises);
        this.claimProcessorLocations = results[0];

        if (this.claimProcessorLocations) {
            // match values to locations table
            this.claimProcessorLocations.forEach(loc => {
                this.claimProcessorLocationList.forEach(locList => {
                    if (locList.LOCID === loc.LOCID) {
                        // update list
                        locList.isProcessorLocation = true;
                        locList.isDefaultProcessor = loc.isDefaultProcessor;
                    }
                });
            });
        }
    }

    createMessage(message, type) {
        this.snackBar.open(message, type, {
            duration: 3000,
            verticalPosition: 'top'
        });
    }

    setSelectedProcessorRevert() {
        if (!this.selectedProcessorRevert) {
            this.selectedProcessorRevert = new CfgArClaimProcessorModel();
        }
        this.selectedProcessorRevert.ClaimProcessorID = this.selectedProcessor.ClaimProcessorID;
        this.selectedProcessorRevert.enumARClaimProcessorID = this.selectedProcessor.enumARClaimProcessorID;
        this.selectedProcessorRevert.WebSiteURL = this.selectedProcessor.WebSiteURL;
        this.selectedProcessorRevert.Name = this.selectedProcessor.Name;
        this.selectedProcessorRevert.ConnectionParametersJSON = this.selectedProcessor.ConnectionParametersJSON;

        this.claimProcessorLocationsRevert = this.claimProcessorLocations;
    }

    changeValue(key, value) {
        this.connectionParametersJSON[key] = value;
        this.selectedProcessorRevert = this.selectedProcessorRevert;
    }

    test() {
        this.selectedProcessorRevert = this.selectedProcessorRevert;
    }

    trackByFn(i: number, items: any) {
        return i; // returning the index itself for avoiding ngFor to change focus after ngModelChange
    }

    setProcessorType(value: any) {


    }

    onTdoTableItemClick($event: TdoTableSelectionEvent) {
    // first clear any previous values set
        this.resetProcessorDetails();

        this.revertSelectedProcessor();

        this.selectedProcessor = $event.model;

        if (this.selectedProcessor.ConnectionParametersJSON === null ||
      this.selectedProcessor.ConnectionParametersJSON === undefined ||
      this.selectedProcessor.ConnectionParametersJSON === '') {

            this.selectedProcessor.ConnectionParametersJSON = this.blankProcessor;
        }


        this.setProcessorDetails();

        console.log(this.selectedProcessor.ConnectionParametersJSON);
        if (this.selectedProcessor.enumARClaimProcessorID === '00000223-1000-0000-0000-000000000001') {
            const z = JSON.parse(this.selectedProcessor.ConnectionParametersJSON);
            this.dxc_UserName = z.Username;
            this.dxc_password = z.Password;
            this.dxc_APIKey = z.APIKey;
            this.dxc_DXCGroupID = z.DXCGroupID;
        }
        this.isEditing = false;
        this.saveDisabled = true;
    }

    removeProcessor(processor: CfgArClaimProcessorModel) {
        this.dialogService.openConfirmDialog('Are you sure you want to remove this processor?').subscribe((res) => {
            if (res) {
                this.claimsProcessorConfigService.removeClaimProcessor(processor).subscribe(saved => {
                    if (saved)
                    {
                        // save successful
                        this.createMessage('Processor removed', 'Success');
                        this.claimProcessorList = this.claimProcessorList.filter(a => a.ClaimProcessorID !== processor.ClaimProcessorID);
                        this.processorTable.updateData(this.claimProcessorList);
                        this.resetProcessorDetails();
                    }
                }, err => {
                    this.createMessage('Error removing processor', 'Error');
                });
            }
        });
    }

    resetProcessorDetails() {
        this.selectedProcessor = new CfgArClaimProcessorModel();
        this.claimProcessorLocationList.forEach(a => {
            a.isProcessorLocation = false;
            a.isDefaultProcessor = false;
        });
        this.connectionParametersJSON = '';
    }

    onClickPasswordEye() {
        if (this.PasswordEyeShowMode === 'password') {
            this.PasswordEyeShowMode = 'text';
            this.PasswordEyeShow = true;
        } else {
            this.PasswordEyeShowMode = 'password';
            this.PasswordEyeShow = false;
        }
    }
}
